// extracted by mini-css-extract-plugin
export default {"heading":"nt-z","corrected":"ot-z","redirectVerbiageContainer":"pt-z","redirectVerbiageText":"qt-z"};